<div class="wrapper billing-export-popup">
  <div mat-dialog-title class="closeIcon d-flex">
    <mat-icon class="ml-auto" (click)="closeDialog()">close</mat-icon>
  </div>
  <!-- Content for export selection-->
  <mat-dialog-content *ngIf="!loading">
    <div class="title d-flex justify-content-center">{{ 'claims.list.exportDialog.title' | translate }}</div>
    <div class="file-type d-flex justify-content-center">
      <div class="file-type-contents d-flex justify-content-around">
        <span class="mr-3">{{ 'claims.list.exportDialog.select' | translate }}</span>
        <div class="export-icons d-flex justify-content-around">
          <div class="excel-icon-wrapper" (click)="pdfSelected=false; excelSelected=true">
            <svg *ngIf="!excelSelected" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
              <g fill="none" fill-rule="evenodd">
                <g stroke="#000" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20.625 29.375h-20V.625h28.75v20z" />
                  <path d="M20.625 29.375v-8.75h8.75" />
                </g>
                <text fill="#595555" font-family="Roboto-Bold, Roboto" font-size="14" font-weight="bold"
                  letter-spacing=".4">
                  <tspan x="7.063" y="17">{{ 'claims.list.exportDialog.x' | translate }}</tspan>
                  <tspan x="16.356" y="17">{{ 'claims.list.exportDialog.l' | translate }}</tspan>
                </text>
              </g>
            </svg>

            <svg *ngIf="excelSelected" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
              <g fill="none" fill-rule="evenodd">
                <g fill="#00857D" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="#00857D" d="M20.625 29.375h-20V.625h28.75v20z" />
                  <path stroke="#FFF" d="M20.625 29.375v-8.75h8.75" />
                </g>
                <text fill="#FFF" font-family="Roboto-Bold, Roboto" font-size="14" font-weight="bold"
                  letter-spacing=".6">
                  <tspan x="6.963" y="17">{{ 'claims.list.exportDialog.x' | translate }}</tspan>
                  <tspan x="16.456" y="17">{{ 'claims.list.exportDialog.l' | translate }}</tspan>
                </text>
              </g>
            </svg>
          </div>
          <div class="separator mx-2"></div>
          <div class="pdf-icon-wrapper" (click)="excelSelected=false; pdfSelected=true">
            <svg *ngIf="!pdfSelected" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
              <g fill="none" fill-rule="evenodd">
                <g stroke="#000" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20.625 29.375h-20V.625h28.75v20z" />
                  <path d="M20.625 29.375v-8.75h8.75" />
                </g>
                <text fill="#595555" font-family="Roboto-Bold, Roboto" font-size="13" font-weight="bold">
                  <tspan x="3.022" y="18">{{ 'claims.list.exportDialog.pdf' | translate }}</tspan>
                </text>
              </g>
            </svg>
            <svg *ngIf="pdfSelected" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
              <g fill="none" fill-rule="evenodd">
                <g fill="#00645E" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20.625 29.375h-20V.625h28.75v20z" />
                  <path d="M20.625 29.375v-8.75h8.75" />
                </g>
                <text fill="#FFF" font-family="Roboto-Bold, Roboto" font-size="13" font-weight="bold">
                  <tspan x="3.022" y="18">{{ 'claims.list.exportDialog.pdf' | translate }}</tspan>
                </text>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="d-flex justify-content-center" *ngIf="!loading">
    <div class="dialog-buttons d-flex justify-content-around flex-wrap">
      <a role="button" class="cancel mb-3" (click)="closeDialog()">{{ 'claims.list.exportDialog.cancel' | translate
        }}</a>
      <a role="button" (click)="download()">{{ 'claims.list.exportDialog.download' | translate }}</a>
    </div>
  </mat-dialog-actions>
  <div class="errors" *ngIf="errors.length > 0">
    <div *ngIf="isCBPPolicy">
      {{ 'claims.list.exportDialog.looksCBP' | translate }} {{ 'claims.list.exportDialog.unavailableCBP' | translate }} 
    </div>
    <div *ngIf="!isCBPPolicy">
      <div *ngFor="let error of errors">
        {{ 'claims.list.exportDialog.looks' | translate }} {{ error?.invoiceNumber }} {{ 'claims.list.exportDialog.unavailable' | translate }}
      </div>
    </div>
    <!-- <div *ngFor="let error of errors"> -->
    <!-- <div *ngIf="!isCBPPolicy">
      {{ 'claims.list.exportDialog.looks' | translate }}  {{ 'claims.list.exportDialog.unavailable' | translate }}
    </div> -->
    <!-- </div> {{ error.invoiceNumber }}-->
  </div>
  <div class="errors" *ngIf="tHistoryError">
    {{ 'claims.list.exportDialog.tHistoryError' | translate }}
  </div>
  <div class="helper mb-1" *ngIf="!loading">{{ 'claims.list.exportDialog.tip' | translate }}</div>

  <!-- Content during loading -->
  <mat-dialog-content *ngIf="loading" class="d-flex flex-column align-items-center loading">
    <div class="spinner-border text-secondary" role="status">
      <span class="sr-only">{{ 'claims.list.exportDialog.loading2' | translate }}</span>
    </div>
    <div class="loading-text">{{ 'claims.list.exportDialog.loading' | translate }}</div>
  </mat-dialog-content>
  <mat-dialog-actions *ngIf="loading" class="d-flex flex-column align-items-center loading">
    <a role="button" class="cancel" mat-dialog-close (click)="closeDialog()">{{ 'claims.list.exportDialog.cancel' |
      translate }}</a>
  </mat-dialog-actions>
</div>